// extracted by mini-css-extract-plugin
module.exports = {"flexHeader":"user_flexHeader__fi9mO","subheader":"user_subheader__IcqRt","fields":"user_fields__3-HSi","buttons":"user_buttons__3uHfZ"};